import { Auth } from "aws-amplify";
import { useContext, useEffect, useRef, useState } from "react";
import {
  GetUserQuery,
  UserType,
  useGetUserQuery,
} from "../../../graphql/types";
import { UserTypeContext } from "../../../UserTypeContext";

const useGetChamberMemberFromUserIdInAuth = ():
  | GetUserQuery["getUser"]["chamberMemberInfo"]
  | undefined => {
  const {
    state: { userType },
  } = useContext(UserTypeContext);
  const [cognitoSub, setCognitoSub] = useState<string | undefined>(undefined);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    if (userType !== UserType.ChamberMemberAdmin) {
      setCognitoSub(undefined);
      return () => {
        isMountedRef.current = false;
      };
    }

    const main = async (): Promise<void> => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (isMountedRef.current) {
          setCognitoSub(user.attributes.sub);
        }
      } catch {
        // not authenticated — leave cognitoSub undefined
      }
    };
    main();
    return () => {
      isMountedRef.current = false;
    };
  }, [userType]);

  const { data } = useGetUserQuery({
    variables: { userId: cognitoSub || "" },
    skip: !cognitoSub || userType !== UserType.ChamberMemberAdmin,
  });

  if (userType !== UserType.ChamberMemberAdmin) {
    return undefined;
  }

  return data?.getUser?.chamberMemberInfo;
};

export default useGetChamberMemberFromUserIdInAuth;
